import React from 'react';
import ReactDOM from 'react-dom';
import RecursiveField from './RecursiveField.jsx';
import {CSSTransitionGroup} from 'react-transition-group'; // ES6

class ModalPopup extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = new Object();

      this.closeModal = function(e)
      {
         this.props.appCallbacks.popModal();
      }.bind(this);
   }

   componentDidMount()
   {
     
   }



   render() {
      
      if(this.props.isOpen){
         
            return (
              <CSSTransitionGroup
              transitionName={this.props.transitionName}
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300} >

                <div className="modalPopupHideBackground" onClick={this.closeModal}>
                <div className='preModalArea'>
                  <div className="modalArea" onClick={(e)=>{e.stopPropagation();}}>
                     {this.props.children}
                  </div>
                  </div>
                </div>
              </CSSTransitionGroup>
            );
        } else {
            return <CSSTransitionGroup
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300} 
              transitionName={this.props.transitionName}/>;
        }
    }
}



export default ModalPopup ;


// WEBPACK FOOTER //
// ./js/ModalPopUp.jsx